module.exports = __webpack_public_path__ + "static/AAMbg-857ceceb5c9778268912b1e19649470a.jpg";